import React, { useRef, useState } from 'react'
import { Card, Col, Modal, Row } from 'react-bootstrap'
import axiosConfig from "../Service/axiosConfig"
import { useNavigate } from 'react-router-dom';
import AlertDeletePopupModal from '../Components/PopupModal/AlertDeletePopupModal';
import { DeletePopupModal, FormParser, PopupModal } from '../Components';
import Masters from "../Components/masters.json"
import { compressImageFile } from "../Utils/compressImage"

const Requirementcontsnt = ({ Data, GetData, statusForm }) => {
    const navigate = useNavigate();
    const thumbnailInputRef = useRef(null);
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("")
    const [popupType, setpopupType] = useState("");
    const [RowId, SetRowId] = useState()
    const [data, SetData] = useState({});
    const [requirementShow, setRequirementShow] = useState(false)
    const [thumbnailShow, setThumbnailShow] = useState(false)
    const [thumbnailFile, setThumbnailFile] = useState(null)
    const [thumbnailPreview, setThumbnailPreview] = useState(null)
    const [thumbnailSaving, setThumbnailSaving] = useState(false)
    const [Message, setMessage] = useState("")
    const [error, setError] = useState(null);
    const DeleteAlert = (id) => {
        SetRowId(id)
        SetAlertDeletePopupType("success")
    }
    const HandleEdit = (id) => {
        axiosConfig.get(`/accounts/audition-requirements/${id}/`).then(res => {
            console.log(res.data)
            SetData({
                ...res.data,
            })
            setRequirementShow(true)
        }).catch(error => {
            console.log(error)
        })
    }
    const CancelAlerrt = () => {
        SetAlertDeletePopupType("error")
    }
    const HandleDelete = async (id) => {
        await axiosConfig.delete(`/accounts/audition-requirements/${id}/`).then(() => {
            SetAlertDeletePopupType("error")
            setDeletepopupType("success")
            GetData && GetData();
        }).catch((error) => {
            setDeletepopupType("error")
            SetAlertDeletePopupType("error")
            console.log(error)
        })
    }
    const handlShow = (id) => {
        navigate(`/dashboard/masters/Audition-applications/${id}/`)
    }
    const StatusChange = (status) => {
        const payload = { requirement_status: status }
        if (status === "closed") {
            payload.approval_status = "approved"
        } else if (status === "live") {
            payload.approval_status = "approved"
        }
        axiosConfig.patch(`/accounts/audition-requirements/${Data.id}/`, payload).then(res => {
            console.log(res)
            GetData && GetData()
            setRequirementShow(false)
            setMessage(status === "closed" ? "Audition approved and closed successfully!" : "Audition reopened successfully!")
            setpopupType("success");
        }).catch(error => {
            console.log(error.response)
        })
    }
    const openThumbnailEditor = () => {
        setThumbnailFile(null)
        setThumbnailPreview(Data?.thumbnail || null)
        setThumbnailShow(true)
        if (thumbnailInputRef.current) {
            thumbnailInputRef.current.value = ""
        }
    }
    const closeThumbnailEditor = () => {
        setThumbnailShow(false)
        setThumbnailFile(null)
        setThumbnailPreview(null)
        setThumbnailSaving(false)
        if (thumbnailInputRef.current) {
            thumbnailInputRef.current.value = ""
        }
    }
    const handleThumbnailSelect = async (event) => {
        const file = event.target.files?.[0]
        if (!file) return
        let uploadFile = file
        try {
            uploadFile = await compressImageFile(file)
        } catch (err) {
            console.log(err)
        }
        setThumbnailPreview((prev) => {
            if (prev && prev.startsWith("blob:")) {
                URL.revokeObjectURL(prev)
            }
            return URL.createObjectURL(uploadFile)
        })
        setThumbnailFile(uploadFile)
    }
    const saveThumbnail = () => {
        if (!thumbnailFile || !Data?.id) return
        setThumbnailSaving(true)
        const formDataToSend = new FormData()
        formDataToSend.append("thumbnail", thumbnailFile)
        axiosConfig.patch(
            `/accounts/audition-requirements/${Data.id}/`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
        )
            .then(() => {
                GetData && GetData()
                closeThumbnailEditor()
                setMessage("Thumbnail updated successfully!")
                setpopupType("success")
            })
            .catch((err) => {
                console.log(err.response)
                setError(err?.response?.data?.detail || "Unable to update thumbnail.")
                setpopupType("error")
                setThumbnailSaving(false)
            })
    }
    const formSubmit = (formData, setFieldErrors) => {
        let OrderToPost = {
            ...formData,
            audition: Data?.audition?.id,
            approval_status: "requested",
        };
        console.log(OrderToPost, "....")
        if (
            formData?.from_age && formData?.to_age &&
            Number(formData.from_age) >= Number(formData.to_age)
        ) {
            const errorMessage = "From age must be less than To age.";
            setFieldErrors(prev => ({
                ...prev,
                from_age: errorMessage,
                to_age: errorMessage
            }));
            return;
        }
        const formDataToSend = new FormData();

        if (OrderToPost.role) formDataToSend.append("role", OrderToPost.role);
        if (OrderToPost.character) formDataToSend.append("character", OrderToPost.character);
        if (OrderToPost.no_of_requirements) formDataToSend.append("no_of_requirements", OrderToPost.no_of_requirements);
        if (OrderToPost.gender) formDataToSend.append("gender", OrderToPost.gender);
        if (OrderToPost.from_age) formDataToSend.append("from_age", OrderToPost.from_age);
        if (OrderToPost.to_age) formDataToSend.append("to_age", OrderToPost.to_age);
        if (OrderToPost.budget) formDataToSend.append("budget", OrderToPost.budget);

        if (OrderToPost.state && Array.isArray(OrderToPost.state)) {
            OrderToPost.state.forEach(s => formDataToSend.append("state", s));
        } else if (OrderToPost.state) {
            formDataToSend.append("state", OrderToPost.state);
        }

        if (OrderToPost.city && Array.isArray(OrderToPost.city)) {
            OrderToPost.city.forEach(c => formDataToSend.append("city", c));
        } else if (OrderToPost.city) {
            formDataToSend.append("city", OrderToPost.city);
        }

        if (OrderToPost.languages && Array.isArray(OrderToPost.languages)) {
            OrderToPost.languages.forEach(l => formDataToSend.append("languages", l));
        } else if (OrderToPost.languages) {
            formDataToSend.append("languages", OrderToPost.languages);
        }

        if (OrderToPost.specification) formDataToSend.append("specification", OrderToPost.specification);
        if (OrderToPost.audition) formDataToSend.append("audition", OrderToPost.audition);
        if (OrderToPost.approval_status) formDataToSend.append("approval_status", OrderToPost.approval_status);
        if (OrderToPost.thumbnail && typeof OrderToPost.thumbnail !== "string") {
            formDataToSend.append("thumbnail", OrderToPost.thumbnail);
        }
        formDataToSend.append("priority", OrderToPost.priority);
        axiosConfig.patch(
            `/accounts/audition-requirements/${Data.id}/`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
        )
            .then(res => {
                console.log(res);
                GetData && GetData();
                setRequirementShow(false);
                setMessage("Requirement Updated Successfully!");
                setpopupType("success");
            })
            .catch(error => {
                console.log(error.response);
            });
    };

    const isApproved = String(Data?.approval_status || "").toLowerCase() === "approved";
    const infoFields = (
        <div className="applictn-dtls">
            {Data.gender && <div className="apply-content">
                Gender : <span className="apply-data"> {Data.gender}</span >
            </div>}
            <div className="apply-content">
                Age : <span className="apply-data"> {Data.from_age} - {Data.to_age} years</span>
            </div>
            {Data.budget && <div className="apply-content">
                Budget : <span className="apply-data"> {Data.budget ? Data.budget : 0}</span>
            </div>}
            {Data.no_of_requirements && <div className="apply-content">
                No. of Positions : <span className="apply-data"> {Data.no_of_requirements}</span>
            </div>}
            <div className="apply-content">
                Preffered Languages: <span className="apply-data"> {Data?.loc_lang?.languages ? Data?.loc_lang?.languages : "Any Language"}</span>
            </div>
            <div className="apply-content">
                Preffered Location: <span className="apply-data"> {Data?.loc_lang?.city
                    ? Data.loc_lang.city : Data?.loc_lang?.state ? Data.loc_lang.state : "Any Location"
                }
                </span>
            </div>
            {Data.specification && <div className="apply-content">
                Specification: <span className="apply-data"> {Data.specification}</span>
            </div>}
            <div className="apply-content">
                Approval : <span className="apply-data"> {Data.approval_status || "--"}</span>
            </div>
            {isApproved && (
                <div className="apply-content">
                    Requirement Status : <span className="apply-data"> {Data.requirement_status || "--"}</span>
                </div>
            )}
            {Data.approval_status === "rejected" && (
                <div className="apply-content">
                    Rejection reason:{" "}
                    <span className="apply-data" style={{ color: "#b91c1c" }}>
                        {Data.rejected_message || Data.approval_message || "--"}
                    </span>
                </div>
            )}
        </div>
    );
    const isClosed = String(Data?.requirement_status || "").toLowerCase() === "closed";
    const actionButtons = (
        <div className="d-grid gap-2">
            <button
                type="button"
                className={`btn w-100 ${isClosed ? "btn-success" : "btn-warning"}`}
                onClick={() => StatusChange(isClosed ? "live" : "closed")}
            >
                {isClosed ? "Reopen Audition" : "Close Audition"}
            </button>
            <button
                type="button"
                className="btn btn-outline-primary w-100 edit-thumbnail-btn"
                onClick={openThumbnailEditor}
            >
                {Data.thumbnail ? (
                    <img
                        src={Data.thumbnail}
                        alt="Edit thumbnail"
                        className="edit-thumbnail-btn-img"
                    />
                ) : (
                    "Edit Thumbnail"
                )}
            </button>
            <button className="btn btn-info w-100" onClick={() => HandleEdit(Data.id)}>
                Edit
            </button>
            <button className="btn btn-secondary w-100" onClick={() => DeleteAlert(Data.id)}>
                Delete
            </button>
            <button
                type="button"
                className="btn btn-primary w-100"
                onClick={() => handlShow(Data.id)}
            >
                Applications ({Data.applications})
            </button>
        </div>
    );

    return (
        <>
            {statusForm ? (
            <div className="row g-3 requirement-detail-split">
                <div className="col-lg-8">
                    <Card className="bax-shadow">
                        <Card.Body>
                            <Card.Title className="card-title-custom">Role - {Data.character}({Data.id})</Card.Title>
                            <Card.Text>
                                {infoFields}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    {statusForm}
                </div>
                <div className="col-lg-4">
                    <Card className="bax-shadow requirement-detail-actions">
                        <Card.Body>
                            <Card.Title className="card-title-custom">Actions</Card.Title>
                            {actionButtons}
                        </Card.Body>
                    </Card>
                </div>
            </div>
            ) : (
            <div className="col-4">
                <Card className="bax-shadow" style={{ position: "relative" }}>
                    <Card.Body>
                        <Card.Title className="card-title-custom">Role - {Data.character}({Data.id})</Card.Title>
                        <Card.Text>
                            {infoFields}
                        </Card.Text>
                        <Card.Footer className="text-center" style={{ background: "none", borderTop: "none", paddingLeft: 0 }}>
                            {actionButtons}
                        </Card.Footer>
                    </Card.Body>
                </Card>
            </div>
            )}
            {AlertDeletePopupType === "success" &&
                <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} HandleDelete={HandleDelete} CancelAlerrt={CancelAlerrt} row={RowId} />
            }
            {deletePopupType != "" &&
                <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} message={"Requirement Deleted Successfully"} />
            }
            {popupType != "" &&
                <PopupModal popupType={popupType} Navigation="" setpopupType={setpopupType} Message={Message} error={error} />
            }
            <Modal
                size="lg"
                show={requirementShow}
                onHide={() => {
                    SetData({})
                    setRequirementShow(false)
                }}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Add Audition Requirements
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormParser modelObject={Masters.AditionRequirements} formData={data} formSubmit={formSubmit} error={Error} />
                </Modal.Body>
            </Modal>
            <Modal
                show={thumbnailShow}
                onHide={closeThumbnailEditor}
                centered
                aria-labelledby="edit-thumbnail-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="edit-thumbnail-title">Edit Thumbnail</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <input
                        ref={thumbnailInputRef}
                        type="file"
                        accept="image/*"
                        className="d-none"
                        onChange={handleThumbnailSelect}
                    />
                    <button
                        type="button"
                        className="requirement-thumbnail-picker"
                        onClick={() => thumbnailInputRef.current?.click()}
                    >
                        {thumbnailPreview ? (
                            <img
                                src={thumbnailPreview}
                                alt="Thumbnail preview"
                                className="requirement-thumbnail-img"
                            />
                        ) : (
                            <span className="text-muted">Click to choose image</span>
                        )}
                    </button>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={closeThumbnailEditor} disabled={thumbnailSaving}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={saveThumbnail}
                        disabled={!thumbnailFile || thumbnailSaving}
                    >
                        {thumbnailSaving ? "Saving..." : "Save"}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export { Requirementcontsnt }
